import { getPrimaryConfig, cfg, environment, Configurable } from "@crystal/config";
const config = getPrimaryConfig();
const originalHost = cfg`${config.prop("brand")}.${config.prop("topLevelDomain")}`;
const sitePath = config.prop("sitePath").chain((sitePath2) => sitePath2 ? `/${sitePath2}` : "");
const devServer = cfg`https://master-glass.glass.deu01.k8s.anteater.dub.aws.k8s.3stripes.net`;
const stgServer = cfg`https://www.staging.${originalHost}`;
const prodServer = cfg`https://www.${originalHost}`;
const glassSite = environment({
  local: cfg`http://localhost:8080`,
  development: devServer,
  staging: stgServer,
  production: prodServer
});
const apiServer = environment({
  local: cfg`http://localhost:8081`,
  development: devServer,
  staging: stgServer,
  production: prodServer
});
const glassConfig = Configurable.props({
  originalHost,
  siteUrl: cfg`${glassSite}${sitePath}`,
  apiServer: cfg`${apiServer}`
});
export {
  glassConfig
};
//# sourceMappingURL=configs.js.map
